import {
    WHAT_IS_AN_ESIM_TRIGGER,
    WHAT_IS_AN_EID_TRIGGER
} from './constants';

const basketPopupsAdobeAnalytics = () => {
    const esimTriggers = document.querySelectorAll(`[${WHAT_IS_AN_ESIM_TRIGGER}]`);
    const eidTriggers = document.querySelectorAll(`[${WHAT_IS_AN_EID_TRIGGER}]`);

    esimTriggers.forEach(esimTrigger =>
        esimTrigger.addEventListener('click', () =>
            sendViewEventToDataLayer('What is an eSIM popup viewed.')
        )
    );

    eidTriggers.forEach(eidTrigger =>
        eidTrigger.addEventListener('click', () =>
            sendViewEventToDataLayer('What is an EID popup viewed.')
        )
    );
};

const sendViewEventToDataLayer = (contentName) => {
    window.dataLayer = window.dataLayer || [];

    dataLayer.push({
        event: 'view',
        view_name: contentName,
        view_type: 'Popup'
    });
};

export const popupsAdobeAnalytics = basketPopupsAdobeAnalytics;
